import { Box, makeStyles, Slider } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editRadius } from 'src/store/modules/imageUpload';

interface radiusProps {
  menuTitle: string;
  type: string;
  max: number;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '20px 16px',
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  input: {
    width: '48px',
    height: '32px',
    marginLeft: '12px',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 500,
    color: '#191F28',
    border: '1px solid #E5E8EB',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    outline: 0,
    '&:focus': {
      borderColor: '#191F28'
    }
  }
}));

const EditRadius: any = ({ menuTitle, type, max, padding = false }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const currentRadius = radius[type] ?? 0;

  const handleRadius = (event: any, newValue: number | number[]) => {
    const newRadius = JSON.parse(`{"${type}": ${newValue}}`);
    dispatch(editRadius({ ...radius, ...newRadius }));
  };

  const handleInputBtnRadius = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRadius = JSON.parse(
      `{"${type}": ${Number(event.target.value.replace(/[^0-9.]/g, ''))}}`
    );
    return dispatch(editRadius({ ...radius, ...newRadius }));
  };

  const handleRadiusRange = () => {
    if (radius[type] < 0) {
      const newMinBtnRadius = JSON.parse(`{"${type}": 0}`);
      dispatch(editRadius({ ...radius, ...newMinBtnRadius }));
    } else if (radius[type] > max) {
      const newMaxBtnRadius = JSON.parse(`{"${type}": ${max}}`);
      dispatch(editRadius({ ...radius, ...newMaxBtnRadius }));
    }
  };

  return (
    <div
      className={classes.root}
      style={{ paddingTop: padding ? '1.5rem' : 0 }}
    >
      <div
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: '13px',
          fontWeight: 600,
          color: '#191F28',
          letterSpacing: '0.02em'
        }}
      >
        {menuTitle} RADIUS
      </div>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <Slider
          value={typeof radius[type] === 'number' ? radius[type] : 0}
          aria-labelledby="input-slider"
          onChange={handleRadius}
          max={max}
          min={0}
        />
        <input
          className={classes.input}
          type="text"
          value={currentRadius}
          onChange={handleInputBtnRadius}
          onBlur={handleRadiusRange}
        />
      </Box>
    </div>
  );
};
export default EditRadius;
